module.exports = __webpack_public_path__ + "static/media/feature-1.f38095bf.jpg";